import { useSelector } from 'react-redux';
import { findCatalogueTemplates } from '../state/state';

const useCatalogueTemplatesDropdown = ({ category }) => {
  const { readStatus, results } = useSelector(({ catalogues }) => findCatalogueTemplates(catalogues, { category }));
  return { readStatus, templates: results };
};

export default {
  useCatalogueTemplatesDropdown,
};
